import React, { useEffect, useRef, useState } from "react";
import { Container } from "./MeetingRoomLocationFilter.styles";
import { TBuilding } from "types/building.types";
import UI from "@mile-meeting/mile-ui";
import LocationFilterDropdown from "./LocationFilterDropdown/LocationFilterDropdown";

//TODO: 해당 타입 밖으로 빼기
export type LocationDataType = {
  building?: { name?: string; id?: string } | null;
  floor?: ({ name: string; id: string } | null)[];
};

export type MeetingRoomLocationFilterProps = {
  locationData: (TBuilding | null)[];
  onChange?: (value: LocationDataType[]) => void;
  onClick?: () => void;
};

const MeetingRoomLocationFilter: React.FC<MeetingRoomLocationFilterProps> = ({ locationData, onChange, onClick }) => {
  const [openLocationFilterDropdown, setOpenLocationFilterDropdown] = React.useState<boolean>(false);
  const [filter, setFilter] = useState<LocationDataType[]>([]);
  const ref = useRef<HTMLDivElement>(null);

  const handleOpenLocationFilterDropdown = () => {
    setOpenLocationFilterDropdown(true);
  };

  //* INFO: 회의실 위치 필터의 삭제 버튼 클릭 시
  const handleRemoveFilter = () => {
    setFilter([]);
    onChange?.([]);
  };

  //* INFO: 회의실 위치 필터의 Input Field에 표시할 값
  const locationInputFieldValue = filter.map(
    (data) =>
      `${data.building === null ? "기타 (건물 미지정)" : data.building?.name ?? "전체 건물"} ${data.building === null ? "-" : data.building?.name !== undefined ? "-" : ""} ${
        data.building?.name !== undefined && data.floor?.length === 0
          ? "전체 층"
          : data.floor?.map((item) => item?.name ?? "기타 (층 미지정)").join(", ")
      }`
  );

  useEffect(() => {
    const handler = (event: any) => {
      if (openLocationFilterDropdown && ref.current && !ref.current.contains(event.target)) {
        setOpenLocationFilterDropdown?.(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => {
      document.removeEventListener("mousedown", handler);
    };
  }, [openLocationFilterDropdown]);

  return (
    <Container onFocus={handleOpenLocationFilterDropdown} onClick={onClick}>
      <UI.InputGroup.TextField
        value={locationInputFieldValue}
        placeholder="회의실 위치"
        prefixIcon="office"
        suffixIcon="removeCircle"
        onClickSuffixIcon={handleRemoveFilter}
        showSuffixIcon={filter.length > 0}
        showPrefixIcon
        size="small"
        width={280}
        disabledFocus
      />
      <LocationFilterDropdown
        open={openLocationFilterDropdown}
        ref={ref}
        filter={filter}
        locationData={locationData}
        onChange={(filter) => {
          onChange?.(filter);
          setFilter(filter);
        }}
      />
    </Container>
  );
};

export default React.memo(MeetingRoomLocationFilter);
